import React from 'react'
import bgImg from '../../assets/AboutUsHeroo.png'
import MobileHeroBg from '../../assets/AboutUsHeroMobb.png'


const AboutOne = () => {
  return (
    <>


      {/* Desktop/Laptop/Tablet Hero Section */}
      <section className="hidden sm:block relative w-full overflow-hidden">
      {/* Responsive height container */}
      <div className="relative w-full h-[40vh] md:h-[45vh] lg:h-[50vh] xl:h-[55vh] 2xl:h-[60vh]">
        {/* Background Image Container */}
        <div className="absolute inset-0 w-full h-full">
          <img
            src={bgImg}
            alt="Hero Background"
            className="absolute inset-0 w-full h-full object-cover object-right-center md:object-right lg:object-center-right"
            style={{ objectPosition: '75% center' }}
          />
          {/* Gradient Overlay for text readability */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent md:from-black/60 md:via-black/40 lg:from-black/50 lg:via-transparent" />
        </div>
        
        {/* Content Container */}
        <div className="relative h-full w-full flex items-center">
          <div className="w-full max-w-[1920px] mx-auto px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-20">
            <div className="w-full md:w-3/4 lg:w-2/3 xl:w-1/2 2xl:w-5/12 space-y-3 md:space-y-4 lg:space-y-5 xl:space-y-6
              max-w-[931px]
              md:max-w-[381px]
              lg:max-w-[556px]
              xl:max-w-[691px]
            ">
              {/* Main Heading */}
              <h1
                className="text-2xl sm:text-3xl md:text-5xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold text-white leading-tight tracking-tight"
                style={{ fontFamily: 'Quicksand, sans-serif' }}
              >
                Who <span className="text-[#FDEB0E] drop-shadow-[0_2px_4px_rgba(0,0,0,0.3)]">We Are</span>
              </h1>
              
              {/* Subheading/Description */}
              <div className="space-y-2">
                <h2
                  className="text-sm sm:text-base md:text-[14px] lg:text-[14px] xl:text-[16px] 2xl:text-2xl text-white/95 md:leading-tight lg:leading-none leading-tight font-medium"
                  style={{ fontFamily: 'Quicksand, sans-serif' }}
                >
                  <span className="text-[#FDEB0E]">
                    MASSTORT HELP
                  </span> {' '}
                    is a legal support platform dedicated to helping individuals & families navigate complex injury and product-related lawsuits. We connect people harmed by dangerous drugs, medical devices, and toxic exposures with legal teams who understand their pain and are ready to fight for justice.
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
      {/* Mobile Hero Section */}
      <section className="flex sm:hidden relative w-full h-[554px] flex-col items-start justify-between overflow-hidden bg-gradient-to-b from-blue-500 via-purple-500 to-pink-500">
        {/* Background Image */}
        <img
          src={MobileHeroBg}
          alt="Hero Background"
          className="absolute inset-0 w-full h-full object-cover z-0"
        />  


        {/* <img
  src={elp}
  alt="Ellipse"
  className="absolute top-0 right-0 w-full object-contain z-10 "
/>


        {/* Content - Positioned at top */}
        <div className="relative z-20 flex flex-col justify-center items-center w-full px-4 pt-[50px]">
          <h1
            className="text-white mb-4 text-center capitalize
              text-[32px] leading-normal
              font-[Quicksand] font-bold"
          >
            Who <span className="text-[#FDEB0E]">We Are</span>
          </h1>

          <h2
            className="text-white text-center
              text-[15px] leading-normal
              font-[Quicksand]"
          >
            <span className="text-[#FDEB0E]">MASSTORT HELP</span> is a legal support platform dedicated to helping individuals & families navigate complex injury and product-related lawsuits. We connect people harmed by dangerous drugs, medical devices, and toxic exposures with legal teams who understand their pain and are ready to fight for justice.
          </h2>
        </div>

        {/* Bottom Image
        <div className="relative z-30 w-full flex justify-center mt-auto">
          <img
            src={imgR}
            alt="Bottom illustration"
            className="h-auto object-contain aspect-[374/227.30]"
          />
        </div> */}
      </section>
    </>
  )
}

export default AboutOne